import React from 'react';
// import { Button } from 'crux';
import styled, { withTheme } from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash/get';
import at from 'lodash/at';
import isArray from 'lodash/isArray';
import ActionButtons from '../../QuestionsLib/ActionButtons';
import { getEnableAdd, getContinueState } from '../../../redux/selector/validations';
import { closeAddListForm, deleteBeneficiary } from '../../../redux/actions/listQuestion';
import { getCSSVariables } from '../../../cruxComponents/utils';
import { scrollQuestionIntoView } from '../../../utils';

const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  @media only screen and (max-width: 767px) {
    // justify-content: center;
    margin-right: 0;
  }
  & i {
    display: none;
  }
`;

const CloseButton = styled.button`
  background: none;
  display: flex;
  align-items: center;
  outline: none;
  font-size: 18px;
  padding: 5px 10px;
  border: 4px solid transparent;
  border-radius: 4px;
  color: ${({ closeButtonTheme }) => closeButtonTheme?.bgColor || '#767676'};
  z-index: 123123;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.2);
    transition: all 0.2s ease-in;
  }
  &:focus {
    outline: none;
    ${({ closeButtonTheme }) =>
      closeButtonTheme &&
      `
			border: ${closeButtonTheme.borderOnFocus};
			border-radius: ${closeButtonTheme.borderRadiusOnFocus};
		`}
  }
`;

function ListQuestionAction({
  enableContinue,
  sectionIndex,
  closeButton,
  handleClose,
  enableAdd,
  listQIds,
  listId,
  listAddButtonLabel,
  listAddBtnTheme,
  role,
  isNestedQ,
  parentListIndex,
  enableOuterActionButton,
  changeMode,
  ...otherProps
}) {
  const theme = get(otherProps, 'theme.config.theme.global');
  const { listButtonsTheme } = theme;
  const cssVariables = getCSSVariables(otherProps.theme);
  const font = at(cssVariables, ['pageOverride.font', 'global.font']);
  if (listButtonsTheme) {
    listButtonsTheme.closeButtonTheme.themeConfiguration.font =
      font?.[0]?.['button-list-close'] || font?.[1]?.['button-list-close'];
  }

  let outerListAdd = enableAdd;
  if (!isNestedQ) {
    outerListAdd = enableAdd && enableOuterActionButton;
  }

  const handleClick = (e, listActionId) => {
    handleClose(sectionIndex, listActionId);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleFocus = (e) => {
    scrollQuestionIntoView({
      element: e.target,
      theme: otherProps.theme,
      role,
    });
  };

  const getDeleteButton = () => {
    return (
      <CloseButton
        onClick={ (e) => handleClick(e, listId) }
        onFocus={ handleFocus }
        name='close-button'
        aria-label='Cancel'
        closeButtonTheme={ get(listButtonsTheme, 'closeButtonTheme.themeConfiguration', {}) }
      >
        <i className='fa fa-times' />
      </CloseButton>
    );
  };

  if (closeButton) {
    return getDeleteButton();
  }
  return (
    <ActionWrapper name='action-wrapper'>
      <ActionButtons
        sectionIndex={ sectionIndex }
        isList
        isListAddButton
        enableContinue={ enableContinue }
        enableAdd={ isNestedQ ? enableAdd : outerListAdd }
        questionIds={ listQIds }
        listId={ listId }
        listAddButtonLabel={ listAddButtonLabel }
        listAddBtnTheme={ listAddBtnTheme }
        handleListActionFocus={ handleFocus }
        isNestedQ={ isNestedQ }
        parentListIndex={ parentListIndex }
        changeMode={ changeMode }
      />
    </ActionWrapper>
  );
}

const mapStateToProps = (state, props) => {
  const id = get(props, 'match.params.id', '');
  const { sectionIndex, requiredListQIds, listQIds } = props;
  const { enableContinue } = getContinueState(state, sectionIndex, id);
  const { editingSectionListIndex, enableOuterActionButton, role } = get(state, 'questions', null);
  return {
    enableContinue,
    enableAdd: getEnableAdd(state, sectionIndex, id, requiredListQIds, listQIds),
    role,
    editingSectionListIndex,
    enableOuterActionButton,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { listFormQuestions = [], closeButton, listId } = props;
  const reflexiveQExist =
    closeButton &&
    listFormQuestions.some(
      (q) => q.child_questions && isArray(q.child_questions_on) && q.child_questions_on.length > 0,
    );
  return {
    handleClose: (sectionIndex) => {
      if (reflexiveQExist) {
        dispatch(deleteBeneficiary(undefined, sectionIndex, listId, `list-close-btn-${listId}`));
      } else {
        dispatch(closeAddListForm(sectionIndex, listId, `list-close-btn-${listId}`));
      }
    },
  };
};

export default withTheme(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ListQuestionAction)),
);
